(() => {
    // newsroom expanded accordions
    const btnMore = document.querySelectorAll('.btn-more');
    btnMore.forEach(btn => {
        const ul = btn.previousElementSibling;
        const liCount = ul.childElementCount;
        const btnCount = btn.querySelector('span');
        const icon = btn.querySelector('.far');
        btnCount.textContent = `All (${liCount})`;
        btn.addEventListener('click', () => {
            if (ul.style.maxHeight) {
                ul.style.maxHeight = null;
                icon.classList.remove('rotate');
                btnCount.textContent = `All (${liCount})`;
                ul.previousElementSibling.scrollIntoView();
            } else {
                ul.style.maxHeight = ul.scrollHeight + 'px';
                icon.classList.add('rotate');
                btnCount.textContent = 'Less';
            }
        });
    });
})();
